import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'acl-owner-delete-modal',
  standalone: false,
  templateUrl: './owner-delete-modal.component.html',
  styleUrl: './owner-delete-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OwnerDeleteModalComponent {
  private readonly modalController = inject(ModalController);

  dismiss(event: string): void {
    this.modalController.dismiss(event);
  }
}
